// import React, { useEffect, useState } from "react";
// import { connect } from "react-redux";
// import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
// import { toastr } from "react-redux-toastr";
// import { Link, useNavigate, useHistory } from "react-router-dom";
// import VmCreateComponent from "./component";


// const VmCreateContainer = (props) => {
 
//   const navigate = useNavigate();
//   const [ warehouseList,  setWarehouseList]= useState([])
//   const [ vmTypeList,  setVmTypeList]= useState([])
//   const [hardwareList, setHardwareList]= useState([])
//   const [corporateList, setCorporateList]= useState([])
//   const [stateName, setStateName] = useState([])
//   const [locationType, setLocationType] = useState ([])
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [uploadStatus, setUploadStatus] = useState(null);
//   const [cityName, setCityName] = useState ([])
//   const [paymentList, setPaymentList] = useState([])
//   const [stateId, setStateId] = useState(undefined);
//   const [formData, setFormData] = useState({
//     // Section 1
//     vmName: '',
//     machine_type_id: '',
//     hardware_type_id: '',
//     warehouse_id: '',
//     corporate_id: '',
//     consumerAppEnabled: '',
//     healthAppEnabled: '',

//     // Section 2
//     share_percentage: '',
//     cohort_ids: '',
//     payment_config_ids: '',
//     serial_number: '',
//     slot_id: '',
//     mv_id: '',
//     capacity: '',

//     // Section 3
//     location_type_id: '',
//     location: '',
//     state: '',
//     city: '',
//     latitude: '',
//     longitude: '',
//     image_path: '',
//   });
//   const [imagePath, setImagePath] = useState(null);
//  const [isImageUploaded, setIsImageUploaded] = useState(false);

//   const [imagePreview, setImagePreview] = useState(null);
//   const [cohortList, setCohortList] = useState([])
 

//   const handleInputChange = (field, value, name) => {
//     setFormData((prevData) => ({
//       ...prevData,
//       [field]: value,
      
//     }));
//   };

 

//   const handleAddNewCorporate=()=>{
//     navigate("/home/configuration/vmcreation/newvmcreation")
//   }

  

//   const handleSelectChange = (selectedValue) => {
//     setFormData((prevUserLimit) => ({
//       ...prevUserLimit,
//       hardware_type_id: selectedValue,
//     }));
//   };
  

//   const handleImageUpload = () => {
//     if (!selectedFile) {
//       toastr.error('Error', 'Please select an image');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('file', selectedFile);

//     props.getDataFromAPI(
//       '/partner/api/v2/s3upload/machine-image',
//       'POST',
//       formData,
//       (response) => {
//         toastr.success('Created', 'Image uploaded successfully');
//         setImagePreview(null);
//         setImagePath(response.image_path);
//         setIsImageUploaded(true)
        
//       },
//       (err) => {
//         toastr.error('Failed', 'Unable to upload image');
//       }
//     );
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];

//     if (file) {
      
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setImagePreview(reader.result);
//       };
//       reader.readAsDataURL(file);

     
//       setSelectedFile(file);
//     } else {
     
//       setImagePreview(null);
//     }
//   };
  
//   // const handleFileChange = (e) => {
//   //   const file = e.target.files[0];
//   //   setSelectedFile(file);
//   //   setImagePath({
//   //     ...imagePath,
//   //     image_path: file,
//   //   });
//   // };
 
//   useEffect(() => {
//     getSeedDataList();
//   }, []);

// const getSeedDataList= ()=>{

//   props.getDataFromAPI(
//     "/partner/api/v2/machine/seed",
//     "GET",
//     undefined,
//     (response) => {
//       console.log("VMtype data:", response);
//       setHardwareList(response.hardware_types);
//       setCorporateList(response.corporates)
//       setLocationType(response.location_types)
//       setCohortList(response.cohorts)
//       setPaymentList(response.payment_configs)
//     },
//     (err) => {
//       console.log("error:", err);
//       toastr.error("Failed", "Unable to fetch Brand category listing");
//     }
//   );

// }

// useEffect(()=>{
//   handleGetStateName()
// }, [])

// const handleGetStateName = () => {
//   props.getDataFromAPI(
//     "/dashboard/api/v2/admin/vendingmachines/location/states",
//     "GET",
//     undefined,
//     (response) => {
//       console.log("state name data:", response);

//       const firstStateId =
//         response && response.list && response.list.length > 0
//           ? response.list[0].id
//           : undefined;

//       setStateName(response);
//       setStateId(firstStateId);
//       handleGetCityName(firstStateId);
//     },
//     (err) => {
//       console.log("error:", err);
//       toastr.error("Failed", "Unable to fetch state listing");
//     }
//   );
// };




// console.log("state id", stateId)
// useEffect(() => {
//   handleGetCityName(stateId ); 
// }, [stateId ]);


// const handleGetCityName = (stateId) => {
//   if (stateId) {
//     props.getDataFromAPI(
//       `/dashboard/api/v2/admin/vendingmachines/location/${stateId}/cities`,
//       "GET",
//       undefined,
//       (response) => {
//         console.log("city name data:", response);
//         setCityName(response);
//       },
//       (err) => {
//         console.log("error:", err);
//         toastr.error("Failed", "Unable to fetch city listing");
//       }
//     );
//   }
// };


//   useEffect(() => {
//     getVMTypeList();
//   }, []);

// const getVMTypeList= ()=>{

//   props.getDataFromAPI(
//     "/dashboard/api/v2/admin/vendingmachines/vmtypes",
//     "GET",
//     undefined,
//     (response) => {
//       console.log("VMtype data:", response);
//       setVmTypeList(response);
//     },
//     (err) => {
//       console.log("error:", err);
//       toastr.error("Failed", "Unable to fetch Brand category listing");
//     }
//   );

// }

//   useEffect(() => {
//     getWarehouseList();
//   }, []);

// const getWarehouseList= ()=>{

//   props.getDataFromAPI(
//     "/partner/api/v2/warehouse/list",
//     "GET",
//     undefined,
//     (response) => {
//       console.log("warehouseData:", response);
//       setWarehouseList(response);
//     },
//     (err) => {
//       console.log("error:", err);
//       toastr.error("Failed", "Unable to fetch Brand category listing");
//     }
//   );

// }


// const handleCreateVm = () => {
//   console.log("hhhh")
//   const cohortIds = Array.isArray(formData.cohort_ids)
//   ? formData.cohort_ids.map(Number)
//   : formData.cohort_ids ? [Number(formData.cohort_ids)] : [];

// const paymentConfigIds = Array.isArray(formData.payment_config_ids)
//   ? formData.payment_config_ids.map(Number)
//   : formData.payment_config_ids ? [Number(formData.payment_config_ids)] : [];

//     const requestData = {
//         name: formData.vmName,
//         hardware_type_id:formData.hardware_type_id,
//         machine_type_id: formData.machine_type_id,
//         health_report_enabled: formData.healthAppEnabled,
//         consumer_app_enabled: formData.consumerAppEnabled,
//         share_percentage: parseInt(formData.share_percentage),
//         warehouse_id: formData.warehouse_id,
//         corporate_id: formData.corporate_id,
//         cohort_ids:cohortIds, 
//         payment_config_ids: paymentConfigIds,
//         address: {
//           street: formData.location,
//           city: formData.city,
//           state: formData.state,
//           latitude: parseFloat(formData.latitude),
//           longitude: parseFloat(formData.longitude),
//           image_path: imagePath, 
//           location_type_id: parseInt(formData.location_type_id),
//         },
//         serial_number: formData.serial_number,
//         slots: [
//           {
//             slot_id: parseInt(formData.slot_id),
//             mv_id: parseInt(formData.mv_id),
//             capacity: parseInt(formData.capacity),
//           },
//         ],
//       };
//   props.getDataFromAPI(
//     `/partner/api/v2/machine`,
//     "POST",
//     requestData,
//     (response) => {
//      toastr.success("created", "VM created successfully")
//      navigate("/home/configuration/vmlist")
//     },
//     (err) => {
     
//       toastr.error("Failed", "Unable to create VM ");
//     }
//   );
// };

  
//  const handleCancel = () => {
//     setImagePreview(null); // Reset the image preview
//   };


//   return (
//     <>
//       <VmCreateComponent
//        handleCreateVm={handleCreateVm}
//        formData={formData}
//        handleInputChange={handleInputChange}
//        handleFileChange={handleFileChange}
//        warehouseList={warehouseList}
//        vmTypeList={vmTypeList}
//        hardwareList={hardwareList}
//        corporateList={corporateList}
//        handleImageUpload={handleImageUpload}
//        handleSelectChange={handleSelectChange}
//        stateName= {stateName}
//        locationType={locationType}
//        selectedFile={selectedFile}
//        uploadStatus={uploadStatus}
//        cityName={cityName}
//        stateId={stateId}
//        setStateId={setStateId}
//        cohortList={cohortList}
//        paymentList={paymentList}
//        imagePreview={imagePreview}
//        handleCancel={handleCancel}
//        isImageUploaded={isImageUploaded}
//       />
//     </>
//   );
// };

// function mapStateToProps(props) {
//   return {
//     props,
//   };
// }
// export default connect(mapStateToProps, {
//   getDataFromAPI,
// })(VmCreateContainer);

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { toastr } from "react-redux-toastr";
import { Link, useNavigate, useHistory, useParams } from "react-router-dom";
import VmCreateComponent from "./component";

const VmCreateContainer = (props) => {
 const { vmId,id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [ warehouseList,  setWarehouseList]= useState([])
  const [ vmTypeList,  setVmTypeList]= useState([])
  const [hardwareList, setHardwareList]= useState([])
  const [corporateList, setCorporateList]= useState([])
  
  const [locationType, setLocationType] = useState ([])
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState(null);
  const [stateName, setStateName] = useState([])
  const [cityName, setCityName] = useState ([])
  const [data, setData] = useState([]);
  const [stateId, setStateId] = useState(undefined);
  const [paymentList, setPaymentList] = useState([])
  const [formData, setFormData] = useState({
    // Section 1
    vmName: '',
    machine_type_id: '',
    hardware_type_id: '',
    warehouse_id: '',
    corporate_id: '',
    consumerAppEnabled: '',
    healthAppEnabled: '',

    // Section 2
    share_percentage: '',
    cohort_ids: '',
    payment_config_ids: '',
    serial_number: '',
    slot_id: '',
    mv_id: '',
    capacity: '',

    // Section 3
    location_type_id: '',
    location: '',
    state: '',
    city: '',
    latitude: '',
    longitude: '',
    image_path: '',
  });
  const [imagePath, setImagePath] = useState(null);
  const [isImageUploaded, setIsImageUploaded] = useState(false);

  const [imagePreview, setImagePreview] = useState(null);
  const [cohortList, setCohortList] = useState([])

  const [showStateList, setShowStateList] = useState(false);
  const [showCityList, setShowCityList] = useState(false);

  const [searchCohortList, setSearchCohortList] = useState([]);
  const [searchCohortValue, setSearchCohortValue] = useState([]);
  const [searchCohortData, setSearchCohortData] = useState(null);
  const [filterCohortType, setFilterCohortType] = useState(null);
  
  const [cohortVMTypeData, setCohortVMTypesData] = useState([]);
  const [filterCohortData, setFilterCohortData] = useState([]);
  const [activeCohortType, setActiveCohortType] = useState("");

  const [checkedCohorts, setCheckedCohorts] = useState([]);
  const handleInputChange = (field, value, name) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleSelectChange = (selectedValue) => {
    setFormData((prevUserLimit) => ({
      ...prevUserLimit,
      hardware_type_id: selectedValue,
    }));
  };

  const handleImageUpload = () => {
    if (!selectedFile) {
      toastr.error('Error', 'Please select an image');
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);

    props.getDataFromAPI(
      '/partner/api/v2/s3upload/machine-image',
      'POST',
      formData,
      (response) => {
        toastr.success('Created', 'Image uploaded successfully');
        setImagePreview(null);
        setImagePath(response.image_path);
        setIsImageUploaded(true);
      },
      (err) => {
        toastr.error('Failed', 'Unable to upload image');
      }
    );
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);

      setSelectedFile(file);
    } else {
      setImagePreview(null);
    }
  };

  useEffect(() => {
    getSeedDataList();
  }, []);

  const getSeedDataList= () => {
    props.getDataFromAPI(
      "/partner/api/v2/machine/seed",
      "GET",
      undefined,
      (response) => {
        console.log("VMtype data:", response);
        setHardwareList(response.hardware_types);
        setCorporateList(response.corporates)
        setLocationType(response.location_types)
        setCohortList(response.cohorts)
        setPaymentList(response.payment_configs)
      },
      (err) => {
        console.log("error:", err);
        toastr.error("Failed", "Unable to fetch seed data  listing");
      }
    );
  };

  useEffect(() => {
    handleGetStateName()
  }, [])

  const handleGetStateName = () => {
    props.getDataFromAPI(
      "/dashboard/api/v2/admin/vendingmachines/location/states",
      "GET",
      undefined,
      (response) => {
        console.log("state name data:", response);
        setStateName(response);
        setStateId(response[0]?.id);
        handleGetCityName(response[0]?.id);
      },
      (err) => {
        console.log("error:", err);
        toastr.error("Failed", "Unable to fetch state listing");
      }
    );
  };

  useEffect(() => {
    handleGetCityName(stateId);
  }, [stateId]);

  const handleGetCityName = (stateId) => {
    if (stateId) {
      props.getDataFromAPI(
        `/dashboard/api/v2/admin/vendingmachines/location/${stateId}/cities`,
        "GET",
        undefined,
        (response) => {
          console.log("city name data:", response);
          setCityName(response);
        },
        (err) => {
          console.log("error:", err);
          toastr.error("Failed", "Unable to fetch city listing");
        }
      );
    }
  };

  useEffect(() => {
    getVMTypeList();
  }, []);

  const getVMTypeList = () => {
    props.getDataFromAPI(
      "/dashboard/api/v2/admin/vendingmachines/vmtypes",
      "GET",
      undefined,
      (response) => {
        console.log("VMtype data:", response);
        setVmTypeList(response);
      },
      (err) => {
        console.log("error:", err);
        toastr.error("Failed", "Unable to fetch vmtype listing");
      }
    );
  };

  useEffect(() => {
    getWarehouseList();
  }, []);

  const getWarehouseList = () => {
    props.getDataFromAPI(
      "/partner/api/v2/warehouse/list",
      "GET",
      undefined,
      (response) => {
        console.log("warehouseData:", response);
        setWarehouseList(response);
      },
      (err) => {
        console.log("error:", err);
        toastr.error("Failed", "Unable to fetch warehouse listing");
      }
    );
  };

  const handleCreateVm = () => {
       const cohortIds = [...new Set(selectedCohorts)];

    const paymentConfigIds = Array.isArray(formData.payment_config_ids)
      ? formData.payment_config_ids.map(Number)
      : formData.payment_config_ids ? [Number(formData.payment_config_ids)] : [];

    const requestData = {
      name: formData.vmName,
      hardware_type_id: formData.hardware_type_id,
      machine_type_id: formData.machine_type_id,
      health_report_enabled: formData.healthAppEnabled,
      consumer_app_enabled: formData.consumerAppEnabled,
      share_percentage: parseInt(formData.share_percentage),
      warehouse_id: formData.warehouse_id,
      corporate_id: formData.corporate_id,
      cohort_ids: cohortIds, 
      payment_config_ids: paymentConfigIds,
      address: {
        street: formData.location,
        city: formData.city,
        state: formData.state,
        latitude: parseFloat(formData.latitude),
        longitude: parseFloat(formData.longitude),
        image_path: imagePath, 
        location_type_id: parseInt(formData.location_type_id),
      },
      serial_number: formData.serial_number,
      slots: [
        {
          slot_id: parseInt(formData.slot_id),
          mv_id: parseInt(formData.mv_id),
          capacity: parseInt(formData.capacity),
        },
      ],
    };
    props.getDataFromAPI(
      `/partner/api/v2/machine`,
      "POST",
      requestData,
      (response) => {
        toastr.success("created", "VM created successfully");
        navigate("/home/configuration/vmlist");
      },
      (err) => {
          console.log(" create err vm api ", err.message);
          toastr.error(`${   "Error",err.status.message}`, {
            position: "top-right",
            autoClose: 1000,
          });
        }
    );
  };

  const handleCancel = () => {
    setImagePreview(null); 
  };



const stagecohortsTypes = [
  {
    "id": 1,
    "name": "mobility"
},
{
    "id": 2,
    "name": "franchisee"
},
{
    "id": 3,
    "name": "df_access"
},
{
    "id": 4,
    "name": "QA"
},
{
    "id": 5,
    "name": "FOOD"
},
{
    "id": 6,
    "name": "service"
},
{
    "id": 7,
    "name": "city_payout"
},
{
    "id": 8,
    "name": "promos"
},
{
    "id": 9,
    "name": "combos"
}
  ];
 
 

  useEffect(() => {
    props.getDataFromAPI(
      "/dashboard/api/v2/admin/vendingmachines/vm-cohorts",
      "GET",
      undefined,
      (response) => {
        console.log("update  cohorts length", response.list.length);
        setData(response.list);
        
        if (response.list.success) {
          navigate("/");
        }
      },
      (err) => {
        console.log("errrororororooro", err);
        toastr.error(
          "Failed",
          "Unable to fetch vending machine cohort  listing"
        );
      }
    );
  }, []);

  const onCohortSearch = (e) => {
    const searchName = e.target.value;
    console.log("search name", searchName);
    setSearchCohortValue(searchName);
    searchCohort(searchName);
  };

  const searchCohort = async (searchCohortValue) => {
  setSearchCohortData(searchCohortValue);

  if (searchCohortValue.trim() === "") {
    
    setSearchCohortList([]);
    return;
  }

  try {
    const url = `/dashboard/api/v2/admin/vendingmachines/vm-cohorts?search_query=${searchCohortValue}`;

    const fetchData = () =>
      new Promise((resolve, reject) => {
        props.getDataFromAPI(
          url,
          "GET",
          undefined,
          (response) => resolve(response),
          (err) => reject(err)
        );
      });

    const TIMEOUT = 5000; 
    const timeout = new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), TIMEOUT)
    );

    const response = await Promise.race([fetchData(), timeout]);

    console.log("Ankit get response", response.list);
    setSearchCohortList(response);
    console.log("SEARCH RES----->", response.list);
  } catch (error) {
    console.error("Error fetching cohort data:", error);
    toastr.error("Failed to fetch data. Please try again.");
  }
};


  const handleCohortTypeClick = (id) => {
    console.log("Clicked on cohort type with ID:", id);

    props.getDataFromAPI(
      `/dashboard/api/v2/admin/vendingmachines/vm-cohorts?associated_user_id=${id}` +
        (id ? `&cohort_type_id=${id}` : ""),
      "GET",
      undefined,
      (response) => {
        console.log("Response from API:", response.list);

        setData(response.list);

        let filteredData = response.list;
        if (id) {
          filteredData = filteredData.filter((cohort) => cohort.type === id);
          console.log("filteredData12", filteredData);
        }

        if (filteredData.length > 0) {
          setFilterCohortData(filteredData);
          setActiveCohortType(id);
        }
      },
      (err) => {
        console.error(err);
      }
    );
  };


const [addedVmCohortIds, setIsCheck] = useState([]);
const [userdetailsCohort, setUserdetailsCohort] = useState([]);
  const [selectedCohorts, setSelectedCohorts] = useState([]);

  console.log("searchCohortData:", userdetailsCohort);

  const FilterCohortData = data
    .filter(
      (vmlist) =>
        !searchCohortData ||
        vmlist.name.toLowerCase().includes(searchCohortData.toLowerCase()) ||
        vmlist.id.toString().includes(searchCohortData)
    )
    .filter((cohort) => !activeCohortType || cohort.type === activeCohortType);

 const addCohorthandleClick = (e) => {
  const { id, checked } = e.target;
  const cohortId = parseInt(id);

  if (checked) {
    if (!addedVmCohortIds.includes(cohortId)) {
      setIsCheck((prev) => [...prev, cohortId]);
      setUserdetailsCohort((prev) => [...prev, { id: cohortId }]);
    }
  } else {
    setIsCheck((prev) => prev.filter((cohortId) => cohortId !== parseInt(id)));
    setUserdetailsCohort((prev) =>
      prev.filter((cohort) => cohort.id !== parseInt(id))
    );
   
  }
};


 const handleCheckboxClick = (e) => {
    const { id, checked } = e.target;
    const cohortId = parseInt(id);

    if (checked) {
      if (!selectedCohorts.includes(cohortId)) {
        setSelectedCohorts((prev) => [...prev, cohortId]);
      }
    } else {
      setSelectedCohorts((prev) => prev.filter((cohortId) => cohortId !== parseInt(id)));
    }
  };

  // Handle modal close
  


  return (
    <>
      <VmCreateComponent
       handleCreateVm={handleCreateVm}
       formData={formData}
       handleInputChange={handleInputChange}
       handleFileChange={handleFileChange}
       warehouseList={warehouseList}
       vmTypeList={vmTypeList}
       hardwareList={hardwareList}
       corporateList={corporateList}
       handleImageUpload={handleImageUpload}
       handleSelectChange={handleSelectChange}
       stateName={stateName}
       locationType={locationType}
       selectedFile={selectedFile}
       uploadStatus={uploadStatus}
       cityName={cityName}
       stateId={stateId}
       setStateId={setStateId}
       cohortList={cohortList}
       paymentList={paymentList}
       imagePreview={imagePreview}
       handleCancel={handleCancel}
       isImageUploaded={isImageUploaded}
       setShowStateList={setShowStateList}
       setShowCityList={setShowCityList}
       showStateList={showStateList}
       showCityList={showCityList}
       handleGetCityName={handleGetCityName}
       handleGetStateName={handleGetStateName}
         Search={searchCohort}
         stagecohortsTypes={stagecohortsTypes}
         activeCohortType={activeCohortType}
         handleCohortTypeClick={handleCohortTypeClick}
         FilterCohortData={FilterCohortData}
         addCohorthandleClick={addCohorthandleClick}
         handleCheckboxClick={handleCheckboxClick}
         selectedCohorts={selectedCohorts}
         
      />
    </>
  );
};

function mapStateToProps(props) {
  return {
    props,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(VmCreateContainer);
